module.exports = __webpack_public_path__ + "VIPM8.png?f9d04aa269b6f568512d57465da51a80";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/motorracing/VIPM8.png
// module id = 153
// module chunks = 0